import { render, staticRenderFns } from "./PartnerWorkerAddPartner.vue?vue&type=template&id=53d13064&"
import script from "./PartnerWorkerAddPartner.vue?vue&type=script&lang=js&"
export * from "./PartnerWorkerAddPartner.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWorkerAddPartner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports